import { ThemeContext } from '../../enums/theme'
import { getIconByName } from '../../icons'
import classNames from 'classnames'
import React, { useContext } from 'react'
import Icon from '../Icon/Icon'
import Permalink from '../Permalink/Permalink'
import styles from './AnnouncementBar.module.scss'
import FreeText from '../FreeText/FreeText'
import { Link } from 'gatsby'

export type AnnouncementBarProps = {
  title: string
  to: string
  target?: '_blank' | '_self'
  className?: string
  category?: string
  bg?: 'light' | 'dark'
  textColor?: 'white' | 'black'
}

export default function AnnouncementBar(
  props: AnnouncementBarProps
): JSX.Element {
  const {
    title,
    to,
    className,
    target = '_self',
    category,
    bg = 'dark',
    textColor,
  } = props
  const { theme } = useContext(ThemeContext)
  return (
    <div
      className={classNames(
        styles.container,
        styles[`theme__${theme}`],
        { [styles.bgLight]: bg === 'light' },
        className
      )}
    >
      <Link to={to} target={target}>
        <FreeText
          type="sm"
          as="span"
          color={bg === 'dark' ? 'white' : 'black'}
          className={classNames({
            [styles[`text__${textColor}`]]: textColor,
          })}
        >
          {category && (
            <span
              className={classNames(styles.category, {
                [styles.bgLight]: bg === 'light',
              })}
            >
              {category}
            </span>
          )}
          <span>{title}</span>
          <Icon
            icon={getIconByName('arrow-right')}
            className={styles.arrow}
            size={18}
          />
        </FreeText>
      </Link>
    </div>
  )
}
